import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M31.1291 9.4752C30.841 9.49164 30.5511 9.49996 30.2594 9.49996C25.9338 9.49996 21.988 7.67051 19.0001 4.66187C16.0121 7.6704 12.0664 9.49976 7.7409 9.49976C7.44925 9.49976 7.15933 9.49145 6.87131 9.47501C6.52027 11.0007 6.3335 12.6008 6.3335 14.25C6.3335 23.1033 11.7159 30.5422 19.0002 32.6514C26.2845 30.5422 31.6668 23.1033 31.6668 14.25C31.6668 12.6009 31.4801 11.0009 31.1291 9.4752Z" />
    <path d="M19 14.25V17.4167M19 23.75H19.0158" />
  </svg>
);
